export default __webpack_public_path__ + "static/media/518.d52c7eb4.gif";